function applyCustomStyles() {
    const style = document.createElement('style');
    style.textContent = `
        .subtotal .theme-money {
            display: none !important;
        }
        .cart-item__column .cart-item__selling-price {
            display: none !important;
        }
    `;
    document.head.appendChild(style);
}

function observeBssQbPriceItem() {
    const targetNode = document.body; // oder ein spezifischerer Container
    if (!targetNode) return;
    const config = { childList: true, subtree: true };

    const callback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const bssQbPriceItem = document.querySelector('.bss-qb-price-item');
                if (bssQbPriceItem) {
                    applyCustomStyles();
                    observer.disconnect(); // Beobachtung stoppen, da Element gefunden wurde
                    return;
                }
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

// Starten Sie die Beobachtung
observeBssQbPriceItem();




// // Input Feld im Warenkorb automatisiert ausfüllen
function extractVatId(customerNoteMetafield) {
    const regex1 = /Umsatzsteuer ID: ([^ ]+)/;
    let match = customerNoteMetafield.match(regex1);
    if (match) {
        return match[1];
    }
    const regex2 = /VAT Validation: ([^ ]+)/;
    match = customerNoteMetafield.match(regex2);

    if (match) {
        return match[1];
    }

    return null;
}

function updateInputField(vatInputField) {
    if (customerWithNoTaxExclusion == true ) {
        const wholeInputField = document.querySelector('.bss-b2b-tax-ex-wrapper');
        if (wholeInputField) wholeInputField.remove();
        return
    }
    
    if (!vatInputField) return;

    const vatId = extractVatId(customerNoteMetafield);

    if (!vatId) return;

    vatInputField.value = vatId;
    
    vatInputField.dispatchEvent(new Event('input', { bubbles: true }));
}

// Mutation Observer wartet bis das BSS Input Feld geladen ist
function observeForVatInput(cartForm) {
    if (!cartForm) return;
    new MutationObserver((mutations, obs) => {
        const vatInputField = document.querySelector('.bss-b2b-vat-input');
        if (vatInputField) {
            updateInputField(vatInputField);
            obs.disconnect();
        }
    }).observe(cartForm, { childList: true, subtree: true });
}

// Prüft, ob das Element bereits existiert, bevor der Observer gestartet wird

document.addEventListener("DOMContentLoaded", function() {
    const existingVatInput = document.querySelector('.bss-b2b-vat-input');
    const cartForm = document.querySelector('#cartform');
    if (cartForm) {
        if (existingVatInput) {
            updateInputField(existingVatInput);
        } else {
            observeForVatInput(cartForm);
        }
    }
});



document.addEventListener('DOMContentLoaded', function() {
    const textContent = document.querySelector('.ds-text-content');
    const readMoreBtn = document.querySelector('.ds-read-more');

    if (!textContent || !readMoreBtn) return;
  
    if (textContent.scrollHeight > textContent.clientHeight) {
      readMoreBtn.classList.add('ds-visible');
    }
  
    readMoreBtn.addEventListener('click', function() {
      textContent.classList.toggle('ds-expanded');
      readMoreBtn.textContent = textContent.classList.contains('ds-expanded') ? 'Weniger anzeigen ↑' : 'Weiterlesen ↓';
    });
  });
  